import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import AddDocuments from "./components/add-documents";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button as ButtonReactstrap,
} from "reactstrap";
import Button from "@mui/material/Button";
import Table from "./../Table";
import Loader from "./../../../Global/Loader";
import { Card } from "reactstrap";
import axios from "axios";
import { saveAs } from "file-saver";
import { Menu, Dropdown } from "antd";
import { Services } from "../../../../repositories/clients/Services";

import * as wjcCore from "@grapecity/wijmo";
import * as wjcXlsx from "@grapecity/wijmo.xlsx";
import "@grapecity/wijmo.styles/wijmo.css";

import {
  MoreOutlined,
  CloudDownloadOutlined,
  MonitorOutlined,
} from "@ant-design/icons";
import "./styles.scss";
import { FilterForRole } from "../../../Global/Permission/filter";
import { moduleActions } from "../../../Global/Permission/constants";
import createModal from "../ModalV2";
import { ShowForRole } from "../../../Global/Permission";

const rutaArchivos = "https://magiclog.blob.core.windows.net/seacargofile/";
// const rest = new RestService()
const size = "18px";
let fileExtension = ["xlsx", "xls", "pdf", "png", "jpg", "gif", "bmp", ".png"];

class Tracking extends Component {
  constructor(props) {
    super(props);
    this._navContainerStyle = { marginTop: "20px" };
    this.state = {
      id: this.props.match ? this.props.match.params.id : -1,
      openDeleteModal: false,
      module: "",
      modal: false,
      workbookView: null,
      sheetIndex: -1,
      nameFile: undefined,
      flat: false,
      isOpen: false,
      shipment: "",
      fullLoad: true,
      shipmentDataPlane: "",
      comments: [],
      removeCard: this.props.removeCard,
      disabledView: false,
      disabledDownload: false,
      data: [],
      columDescripcion: false,
      columns: this.props.storage
        ? [
          {
            label: this.props.t("actions"),
            key: "",
            minWidth: 60,
            align: "center",
            custom: (value) => (
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item onClick={() => this.viewDocument(value, true)}>
                      <CloudDownloadOutlined style={{ fontSize: size }} />
                      <i className="global-text"> Download</i>
                    </Menu.Item>
                    {!this.props.isMobil ? (
                      <Menu.Item
                        onClick={() => this.viewDocument(value, false)}
                      >
                        <MonitorOutlined style={{ fontSize: size }} />{" "}
                        <i className="global-text">View</i>
                      </Menu.Item>
                    ) : (
                      ""
                    )}
                  </Menu>
                }
                placement="topRight"
              >
                <div>
                  <MoreOutlined
                    className="btn-expander"
                    style={{ fontSize: "26px" }}
                  />
                </div>
              </Dropdown>
            ),
          },
          { label: this.props.t("document_name"), key: "DocumentName" },
          { label: this.props.t("type_document"), key: "Type" },
          // { label: 'Categoría', key: 'Category' },
          // { label: 'Fecha de Creación', key: 'CreationDate' },
          // { label: 'Actualizado por', key: 'CreateBy' },
          { label: this.props.t("created_on"), key: "CreationDateDocument" },
          { label: "Actualizado por", key: "CreationDateDocument" },

          // {
          //     label: 'Descarga', key: 'URL', custom: (value) => {
          //         return (
          //             <Button style={{color: 'rgb(93, 156, 236)'}} >
          //             {/* <a href={value} className="fas fa-download fa-2x " download="sample.PDF"> </a> */}
          //             {/* <a className="fas fa-download fa-2x dataIcon" onClick={() => window.open(value.URL)}></a> */}
          //             <a className="fas fa-download fa-2x dataIcon " href={value.URL}></a>
          //             </Button>
          //         )
          //     }
          // },
          {
            label: "Visualizar",
            key: "DocumentKeyAsString",
            custom: (value) => {
              return (
                <Button
                  style={{ color: "rgb(101, 101, 101)" }}
                  disabled={this.disabledView}
                >
                  <button
                    style={{ color: "#5d9cec" }}
                    className="fas fa-search fa-2x  dataIcon"
                    onClick={() =>
                      value.origin && value.origin === "expo"
                        ? this.viewDocument(
                          value.DocumentKeyAsString,
                          value.DocumentName,
                          value.Type
                        )
                        : window.open(value.DocumentKeyAsString)
                    }
                  ></button>
                </Button>
              );
            },
          },
        ]
        : this.props.columDescripcion === true
          ? [
            {
              label: this.props.t("actions"),
              key: "",
              minWidth: 60,
              align: "center",
              custom: (value) => (
                <Dropdown
                  overlay={
                    <Menu>
                      <Menu.Item onClick={() => this.viewDocument(value, true)}>
                        <CloudDownloadOutlined style={{ fontSize: size }} />
                        <i className="global-text"> Download</i>
                      </Menu.Item>
                      {!this.props.isMobil ? (
                        <Menu.Item
                          onClick={() => this.viewDocument(value, false)}
                        >
                          <MonitorOutlined style={{ fontSize: size }} />{" "}
                          <i className="global-text">View</i>
                        </Menu.Item>
                      ) : (
                        ""
                      )}
                    </Menu>
                  }
                  placement="topRight"
                >
                  <div>
                    <MoreOutlined
                      className="btn-expander"
                      style={{ fontSize: "26px" }}
                    />
                  </div>
                </Dropdown>
              ),
            },
            // { label: 'Nombre del Documento', key: 'Name' },
            // { label: 'Tipo de Documento', key: 'Type' },
            // { label: 'Descripción', key: 'Descripcion' },
            // { label: 'Fecha de Creación', key: 'CreationDate' },
            // { label: 'Actualizado por', key: 'CreateBy' },
            { label: this.props.t("document_name"), key: "DocumentName" },
            { label: "Tipo de Documento", key: "Type" },
            // { label: 'Categoría', key: 'Category' },
            // { label: 'Fecha de Creación', key: 'CreationDate' },
            // { label: 'Actualizado por', key: 'CreateBy' },
            { label: this.props.t("created_on"), key: "CreationDateDocument" },
            { label: "Actualizado por", key: "CreationDateDocument" },

            // {
            //   label: 'Descarga', key: 'URL', custom: (value) => {
            //     return (
            //       <Button style={{ color: 'rgb(93, 156, 236)' }} >
            //         {/* <a href={value} className="fas fa-download fa-2x " download="sample.PDF"> </a> */}
            //         {/* <a className="fas fa-download fa-2x dataIcon" onClick={() => window.open(value.URL)}></a> */}
            //         <a className="fas fa-download fa-2x dataIcon " href={value.URL}> </a>
            //       </Button>
            //     )
            //   }
            // },
            // {
            //   label: 'Visualizar', key: 'DocumentKeyAsString', custom: (value) => {
            //     return (
            //       value.Type === 'xlsx' ? <></> :
            //         <Button style={{ color: 'rgb(101, 101, 101)' }} disabled={this.disabledView}>
            //           <button style={{ color: '#5d9cec' }} className="fas fa-search fa-2x  dataIcon" onClick={() => value.origin && value.origin === 'expo' ? this.viewDocument(value.DocumentKeyAsString, value.Name, value.Type) : window.open(value.DocumentKeyAsString)}></button>
            //         </Button>
            //     )
            //   }
            // },
          ]
          : [
            {
              label: this.props.t("actions"),
              key: "",
              minWidth: 60,
              align: "center",
              custom: (value) => (
                <>
                  {fileExtension.includes(
                    value.fileExtension.replace(".", "")
                  ) ? (
                    !this.props.isMobil ? (
                      <Dropdown
                        overlay={
                          <Menu>
                            {value.FrontDocuments === "1" ? (
                              <>
                                {
                                  <ShowForRole
                                    rol={this.props.rolId}
                                    moduleAction={moduleActions.SHIPMENT_DOWNLOAD_DOCUMENT}
                                  >
                                    <Menu.Item>
                                      <div style={{ display: "inline-flex", alignItems: "center" }} className='container-options'>
                                        <CloudDownloadOutlined style={{ fontSize: size }} />
                                        <a style={{ color: "#000a2e", textDecoration: 'none', fontWeight: '100' }} href={value.URL}>
                                          <i style={{ marginLeft: "10px" }} className='global-text'>
                                            <span className="global-text" style={{ fontSize: '14px', fontStyle: 'italic' }}>
                                              {this.props.t("download")}
                                            </span>
                                          </i>
                                        </a>
                                      </div>
                                    </Menu.Item>
                                  </ShowForRole>
                                }
                                {!["xlsx"].includes(value.fileExtension) && (

                                  <ShowForRole
                                    rol={this.props.rolId}
                                    moduleAction={moduleActions.SHIPMENT_VIEW_DOCUMENT}
                                  >
                                    <Menu.Item onClick={() => {
                                      window.open(`${Services.ORDEN_SERV.path}orderDocument/document/view/pdf/?url=${value.URL}`);
                                    }}>
                                      <div style={{ display: "inline-flex", alignItems: "center", marginLeft: '-15px' }} className='container-options'>
                                        <i style={{ marginLeft: "10px", fontSize: '19px', marginLeft: '12px' }} className="global-text icon-search">
                                          <span className="global-text" style={{ fontSize: '14px', fontStyle: 'italic', marginLeft: '4px' }}>
                                            {this.props.t("open")}
                                          </span>
                                        </i>
                                      </div>
                                    </Menu.Item>
                                  </ShowForRole>
                                )}
                              </>
                            ) : (
                              <Menu.Item
                                onClick={() =>
                                  this.setState({ fullLoad: false }, () =>
                                    this.getDocument(
                                      1,
                                      value.fileExtension,
                                      value.id,
                                      value.title,
                                      value.Instance
                                    )
                                  )
                                }
                              >
                                <i className="global-text">
                                  {this.props.t("download")}
                                </i>
                              </Menu.Item>
                            )}
                            {!this.props.isMobil ? (
                              // ['1', '7'].includes(this.props.rolId) && value.FrontDocuments === '1' && value.UserId === parseInt(this.props._user) ?
                              value.FrontDocuments === "1" ? (
                                <>
                                  <ShowForRole
                                    rol={this.props.rolId}
                                    moduleAction={moduleActions.SHIPMENT_DELETE_DOCUMENT}
                                  >
                                    <FilterForRole
                                      rol={parseInt(this.props.rolId)}
                                      userId={parseInt(this.props._user)}
                                      moduleAction={
                                        moduleActions.SHIPMENT_DELETE_DOCUMENT
                                      }
                                      userCreatedId={value.UserId}
                                    >

                                      <Menu.Item onClick={() => this.rmDocument(value)}>
                                        <div style={{ display: "inline-flex", alignItems: "center", marginLeft: '-4px' }} className='container-options' >
                                          <span style={{ fontSize: '18px' }} disabled={props.disabled} className="icon-delete global-text" >  <span className=" global-text" style={{ fontSize: '14px', fontStyle: 'italic' }}>{this.props.t("eliminate")}</span></span>
                                        </div>
                                      </Menu.Item>
                                    </FilterForRole>
                                  </ShowForRole>

                                </>
                              ) :
                                !["xlsx"].includes(value.fileExtension) ?
                                  <Menu.Item
                                    onClick={() =>
                                      this.setState({ fullLoad: false }, () =>
                                        this.getDocument(
                                          2,
                                          value.fileExtension,
                                          value.id,
                                          value.title,
                                          value.Instance
                                        )
                                      )
                                    }
                                  >
                                    <i className="global-text">
                                      {this.props.t("open")}
                                    </i>
                                  </Menu.Item> : false
                            ) : (
                              ""
                            )}
                          </Menu>
                        }
                        placement="topRight"
                      >
                        <div>
                          <MoreOutlined
                            className="btn-expander"
                            style={{
                              fontSize: "26px",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </Dropdown>
                    ) : (
                      <div>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn-round btn-icon"
                            color="default"
                            outline
                          >
                            <div>
                              <MoreOutlined
                                className="btn-expander"
                                style={{
                                  fontSize: "26px",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          </DropdownToggle>
                          <DropdownMenu right>
                            <DropdownItem
                              onClick={() =>
                                this.setState({ fullLoad: false }, () =>
                                  this.getDocument(
                                    1,
                                    value.fileExtension,
                                    value.id,
                                    value.title
                                  )
                                )
                              }
                            >
                              {this.props.t("download")}
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    )
                  ) : (
                    <Dropdown
                      overlay={
                        <Menu>
                          <Menu.Item
                            onClick={() =>
                              this.setState({ fullLoad: false }, () =>
                                this.getDocument(
                                  1,
                                  value.fileExtension,
                                  value.id,
                                  value.title
                                )
                              )
                            }
                          >
                            <i className="global-text">
                              {" "}
                              {this.props.t("download")}
                            </i>
                          </Menu.Item>
                        </Menu>
                      }
                      placement="topRight"
                    >
                      <div>
                        <MoreOutlined
                          className="btn-expander"
                          style={{
                            fontSize: "26px",
                            cursor: "pointer",
                          }}
                        />
                      </div>
                    </Dropdown>
                  )}
                </>
              ),
            },
            { label: this.props.t("document_name"), key: "title" },
            {
              label: this.props.t("type_document"),
              custom: (value) => value.fileExtension.replace(".", ""),
            },
            { label: this.props.t("document_category"), key: "category" },
            // { label: 'Categoría', key: 'Category' },
            // { label: 'Fecha de Creación', key: 'CreationDate' },
            // { label: 'Actualizado por', key: 'CreateBy' },

            // {
            //   label: 'Descarga', key: 'URL', custom: (value) => {
            //     return (
            //       <Button style={{ color: '#020E3A' }} >
            //         {/* <a href={value} className="fas fa-download fa-2x " download="sample.PDF"> </a> */}
            //         {/* <a className="fas fa-download fa-2x dataIcon" onClick={() => window.open(value.URL)}></a> */}
            //         <a className="fas fa-download fa-2x dataIcon seacargo-icon" href={value.URL}> </a>
            //       </Button>
            //     )
            //   }
            // },
            // {
            //   label: 'Visualizar', key: 'DocumentKeyAsString', custom: (value) => {
            //     return (
            //       <Button style={{  color: '#020E3A'  }} disabled={this.disabledView}>
            //         <button style={{ color: '#020E3A' }} className="fas fa-search fa-2x  dataIcon" onClick={() => value.origin && value.origin === 'expo' ? this.viewDocument(value.DocumentKeyAsString, value.Name, value.Type) : window.open(value.DocumentKeyAsString)}></button>
            //       </Button>
            //     )
            //   }
            // },
          ],
    };
  }

  rmDocument = (value) => {
    this.setState({
      openDeleteModal: true,
      modalValue: value,
      nameDoc: value.title,
    });
  };

  toggleDeleteModal = (evt) => {
    this.setState((prevState) => ({
      openDeleteModal: !prevState.openDeleteModal,
    }));
  };

  removeDocumentModal = async () => {
    let values = this.state.modalValue;
    let url = `${Services.TRACEABILITY.path}trazabilidad/delete-document/`;

    await axios.post(url, values).then((success) => {
      if (success.data.code === 200) {
        this.setState({ openDeleteModal: false }, () => this.getDocuments());
      } else {
        console.error("No se pudo eliminar el documento");
      }
    });
  };

  componentDidMount = () => {
    this.setState({
      data: this.props.dataDoc ? this.props.dataDoc : [],
      shipment: this.props.shipment,
      shipmentDataPlane: this.props.shipmentDataPlane,
      module: this.props.module,
    });
  };

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      data: nextProps.dataDoc ? nextProps.dataDoc : [],
      shipment: nextProps.shipment,
      shipmentDataPlane: nextProps.shipmentDataPlane,
      module: nextProps.module,
    });
  };

  getDocuments = () => {
    let { shipment } = this.state;
    let body = {
      code: shipment.ShipmentCode,
      instance: shipment.Instance,
      shipmentId: shipment.ShipmentId,
    };
    axios.post(`${Services.UPLOADTP.path}document/documentbyid`, body);
    let url = `${Services.TRACEABILITY.path}trazabilidad/get-documents`;
    axios
      .post(url, body)
      .then((resp) => {
        this.props.setNewDocs(resp.data.data);
      })
      .catch((erro) => {
        console.log("🚀 ~ Tracking ~ axios.post ~ erro:", erro);
      });
  };

  getCommentsView = () => {
    let { shipmentDataPlane } = this.state;
    let id = shipmentDataPlane.ShipmentId;
    // let id = 122;
    let moduleId = 3;
    // axios.get(`http://192.168.1.73:3017/documents/findDocumentsView/${moduleId}/${id}`)
    let url = `https://poseidonbooking.azurewebsites.net/documents/findDocumentsView/${moduleId}/${id}`;
    axios
      .get(url)
      .then((response) => {
        let newData = this.state.data;
        let viewData = response.data.data;
        viewData.map((e) => {
          newData.push(e);
          return e;
        });
        this.setState({ data: newData });
      })
      .catch((error) => { });
  };

  toggle = (evt) => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  toggleViewXls = () => this.setState({ isOpen: !this.state.isOpen });

  callback = (success) => {
    this.setState(
      (prevState) => ({
        modal: !prevState.modal,
      }),
      () => this.getDocuments()
    );
  };

  onError = (error) => {
    console.log(error);
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };

  base64ToBlob = (base64, type = "application/octet-stream") => {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
  };

  getDocument = (type, ext, id, name, instance) => {
    let { shipment, module } = this.state;
    let Instance = module
      ? module !== "myProfile"
        ? shipment.Instance
        : instance
      : shipment.Instance;
    this.setState({
      nameFile: `${name}.${ext}`,
      flat: false,
    });

    let data = {
      record_id: id,
      Instance: Instance,
    };
    console.log("data", data);

    axios
      .post(`${Services.UPLOADTP.path}document/documentbyid`, data)
      .then((response) => {
        if (type === 1) {
          console.log("entre a la descarga");
          const linkSource = `data:application/${type};base64,${response.data.data}`;
          const downloadLink = document.createElement("a");
          // const fileName = 'REPORT_COST_' + new Date() + '.xlsx';
          const fileName = `${name}.${ext}`;
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          this.setState({
            loading: false,
          });
        } else {
          const blob = this.base64ToBlob(response.data.data, "application/pdf");
          const url = URL.createObjectURL(blob);
          if (ext !== "xlsx") {
            let pdfWindow = window.open("");
            pdfWindow.document.write(
              ext === "png" || ext === "jpg"
                ? // (`<iframe width='100%'  height='100%'  type="application/${Type}" src='data:application/${Type};base64,${response.data} "'  ></iframe> `)
                `<img  src='data:application/${ext};base64,${response.data.data}'  /> `
                : //(`<iframe width='100%' type="application/${Type}"  height='100%' src='${rutaArchivos}${URL}'></iframe> `)
                `<iframe width='100%' type="application/${ext}"  height='100%' src='${url}'></iframe> `
            );
          } else {
            const linkSource = `data:application/${type};base64,${response.data.data}`;
            let workbook = new wjcXlsx.Workbook();
            workbook.loadAsync(linkSource, (result) => {
              this.setState({ workbookView: result });
              this._drawSheet(this.state.workbookView.activeWorksheet || 0);
              this.setState({ flat: !this.state.flat });
            });

            this.setState({ file: linkSource, isOpen: !this.state.isOpen });
            // ExcelRenderer(blob, (err, resp) => {
            //   console.log("🚀 ~ file: App.js ~ line 27 ~ App ~ ExcelRenderer ~ resp", resp)
            //   if (err) {
            //     console.log(err);
            //   }
            //   else {
            //     this.setState({
            //       // dataLoaded: true,
            //       cols: resp.cols,
            //       rows: resp.rows,
            //       isOpen: !this.state.isOpen
            //     });
            //   }
            // });
          }
        }
        this.setState({ fullLoad: true });
      })
      .catch((error) => {
        console.log("error", error);
        this.setState({ fullLoad: true });
      });
  };

  viewDocument = (id, name, Type, URL) => {
    let data = {
      id: id,
      name: name,
    };

    // let file_path = (rutaArchivos + URL)
    // var a = document.createElement('A');
    // a.href = file_path;
    // a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);

    // axios({
    //   url: encodeURI(rutaArchivos + URL),
    //   method: 'GET',
    //   responseType: 'blob', // important
    // }).then((response) => {
    //   const url = window.URL.createObjectURL(new Blob([response.data]));
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.setAttribute('download', 'file.pdf');
    //   document.body.appendChild(link);
    //   link.click();
    // });

    axios({
      method: "get",
      url: encodeURI(rutaArchivos + URL), // blob url eg. blob:http://127.0.0.1:8000/e89c5d87-a634-4540-974c-30dc476825cc
      responseType: "blob",
    }).then(function (response) {
      console.log("URL", URL);
      if (name) {
        saveAs(response.data, URL);
      } else {
        let pdfWindow = window.open("");
        pdfWindow.document.write(
          Type === "png" || Type === "jpg"
            ? // (`<iframe width='100%'  height='100%'  type="application/${Type}" src='data:application/${Type};base64,${response.data} "'  ></iframe> `)
            `<img  src='${rutaArchivos}${URL}'  /> `
            : //(`<iframe width='100%' type="application/${Type}"  height='100%' src='${rutaArchivos}${URL}'></iframe> `)
            `<iframe width='100%' type="application/${Type}"  height='100%' src='${rutaArchivos}${URL}'></iframe> `
        );
      }
    });

    this.setState({ fullLoad: true });
    // axios.post(`${Services.Post_Preview_Doc_Export_ForId.path}/document/DocumentsPreview/`, data).then(success => {
    //   var base64str = success.data.base64;
    //   let pdfWindow = window.open("")
    //   pdfWindow.document.write(Type === 'png' || Type === 'jpg' ?
    //     (`<iframe width='100%'  height='100%'  src=${base64str} ></iframe> `)
    //     :rutaArchivos//  (`<iframe width='100%' type="application/${Type}"  height='100%' src='data:application/${Type};base64, ` + encodeURI(base64str) + "'></iframe> "))
    //     (`<iframe width='100%' type="application/${Type}"  height='100%' src='${rutaArchivos}${URL}'></iframe> `))
    // }).catch(error => {
    //   console.warn(error);
    // });
  };
  ////#region XLS
  _drawSheet = (sheetIndex) => {
    let drawRoot = document.getElementById("tableHost");
    drawRoot.textContent = "";
    this.setState({ sheetIndex: sheetIndex });
    this._drawWorksheet(
      this.state.workbookView,
      sheetIndex,
      drawRoot,
      200,
      100
    );
  };
  _drawWorksheet = (workbook, sheetIndex, rootElement, maxRows, maxColumns) => {
    //NOTES:
    //Empty cells' values are numeric NaN, format is "General"
    //
    //Excessive empty properties:
    //fill.color = undefined
    //
    // netFormat should return '' for ''. What is 'General'?
    // font.color should start with '#'?
    // Column/row styles are applied to each cell style, this is convenient, but Column/row style info should be kept,
    // for column/row level styling
    // formats conversion is incorrect - dates and virtually everything; netFormat - return array of formats?
    // ?row heights - see hello.xlsx
    if (
      !workbook ||
      !workbook.sheets ||
      sheetIndex < 0 ||
      workbook.sheets.length == 0
    ) {
      return;
    }
    //
    sheetIndex = Math.min(sheetIndex, workbook.sheets.length - 1);
    //
    if (maxRows == null) {
      maxRows = 200;
    }
    //
    if (maxColumns == null) {
      maxColumns = 100;
    }
    //
    // Namespace and XlsxConverter shortcuts.
    let sheet = workbook.sheets[sheetIndex],
      defaultRowHeight = 20,
      defaultColumnWidth = 60,
      tableEl = document.createElement("table");
    //
    tableEl.border = "1";
    tableEl.style.borderCollapse = "collapse";
    //
    let maxRowCells = 0;
    for (let r = 0; sheet.rows && r < sheet.rows.length; r++) {
      if (sheet.rows[r] && sheet.rows[r].cells) {
        maxRowCells = Math.max(maxRowCells, sheet.rows[r].cells.length);
      }
    }
    //
    // add columns
    let columns = sheet.columns || [],
      invisColCnt = columns.filter((col) => col.visible === false).length;
    //
    if (sheet.columns) {
      maxRowCells = Math.min(Math.max(maxRowCells, columns.length), maxColumns);
      //
      for (let c = 0; c < maxRowCells; c++) {
        let col = columns[c];
        //
        if (col && !col.visible) {
          continue;
        }
        //
        let colEl = document.createElement("col");
        tableEl.appendChild(colEl);
        let colWidth = defaultColumnWidth + "px";
        if (col) {
          this._importStyle(colEl.style, col.style);
          if (col.autoWidth) {
            colWidth = "";
          } else if (col.width != null) {
            colWidth = col.width + "px";
          }
        }
        colEl.style.width = colWidth;
      }
    }
    //
    // generate rows
    let rowCount = Math.min(maxRows, sheet.rows.length);
    for (let r = 0; sheet.rows && r < rowCount; r++) {
      let row = sheet.rows[r],
        cellsCnt = 0; // including colspan
      //
      if (row && !row.visible) {
        continue;
      }
      //
      let rowEl = document.createElement("tr");
      tableEl.appendChild(rowEl);
      //
      if (row) {
        this._importStyle(rowEl.style, row.style);
        if (row.height != null) {
          rowEl.style.height = row.height + "px";
        }
        //
        for (let c = 0; row.cells && c < row.cells.length; c++) {
          let cell = row.cells[c],
            cellEl = document.createElement("td"),
            col = columns[c];
          //
          if (col && !col.visible) {
            continue;
          }
          //
          cellsCnt++;
          //
          rowEl.appendChild(cellEl);
          if (cell) {
            this._importStyle(cellEl.style, cell.style);
            let value = cell.value;
            //
            if (!(value == null || value !== value)) {
              // TBD: check for NaN should be eliminated
              if (wjcCore.isString(value) && value.charAt(0) == "'") {
                value = value.substr(1);
              }
              let netFormat = "";
              if (cell.style && cell.style.format) {
                netFormat = wjcXlsx.Workbook.fromXlsxFormat(
                  cell.style.format
                )[0];
              }
              let fmtValue = netFormat
                ? wjcCore.Globalize.format(value, netFormat)
                : value;
              cellEl.innerHTML = wjcCore.escapeHtml(fmtValue);
            }
            //
            if (cell.colSpan && cell.colSpan > 1) {
              cellEl.colSpan = this._getVisColSpan(columns, c, cell.colSpan);
              cellsCnt += cellEl.colSpan - 1;
              c += cell.colSpan - 1;
            }
            //
            if (cell.note) {
              wjcCore.addClass(cellEl, "cell-note");
              cellEl.title = cell.note.text;
            }
          }
        }
      }
      //
      // pad with empty cells
      let padCellsCount = maxRowCells - cellsCnt - invisColCnt;
      for (let i = 0; i < padCellsCount; i++) {
        rowEl.appendChild(document.createElement("td"));
      }
      //
      if (!rowEl.style.height) {
        rowEl.style.height = defaultRowHeight + "px";
      }
    }
    //
    // do it at the end for performance
    rootElement.appendChild(tableEl);
  };
  //
  _getVisColSpan = (columns, startFrom, colSpan) => {
    let res = colSpan;
    //
    for (
      let i = startFrom;
      i < columns.length && i < startFrom + colSpan;
      i++
    ) {
      let col = columns[i];
      if (col && !col.visible) {
        res--;
      }
    }
    //
    return res;
  };
  //
  _importStyle = (cssStyle, xlsxStyle) => {
    if (!xlsxStyle) {
      return;
    }
    //
    if (xlsxStyle.fill) {
      if (xlsxStyle.fill.color) {
        cssStyle.backgroundColor = xlsxStyle.fill.color;
      }
    }
    //
    if (xlsxStyle.hAlign && xlsxStyle.hAlign != wjcXlsx.HAlign.Fill) {
      cssStyle.textAlign = wjcXlsx.HAlign[xlsxStyle.hAlign].toLowerCase();
    }
    //
    let font = xlsxStyle.font;
    if (font) {
      if (font.family) {
        cssStyle.fontFamily = font.family;
      }
      if (font.bold) {
        cssStyle.fontWeight = "bold";
      }
      if (font.italic) {
        cssStyle.fontStyle = "italic";
      }
      if (font.size != null) {
        cssStyle.fontSize = font.size + "px";
      }
      if (font.underline) {
        cssStyle.textDecoration = "underline";
      }
      if (font.color) {
        cssStyle.color = font.color;
      }
    }
  };
  //#endregion
  render() {
    let { modal, openDeleteModal } = this.state
    let lists = [];
    //
    if (this.state.workbookView != null) {
      lists = this.state.workbookView.sheets.map((sheet, index) => {
        return (
          <li className={index === this.state.sheetIndex ? "active" : ""}>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                this._drawSheet(index);
              }}
            >
              <span>{sheet.name}</span>
            </a>
          </li>
        );
      });
    }
    return (
      <>
        <Loader hidden={this.state.fullLoad}></Loader>
        {this.state.removeCard ? (
          <div>
            <div className="row">
              <div className="col-12">
                <Table
                  headerClass="headerTable"
                  columns={this.state.columns}
                  data={this.state.data}
                  itemsByPage={10}
                  options={{
                    large: false,
                    downloads: {
                      pdf: false,
                      xlsx: false,
                    },
                    pagination: true,
                    search: false,
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-11"></div>
              {/* <div className="col-1">
          <Fab color="primary" size="small" aria-label="add" onClick={this.toggle}>
            <AddIcon />
          </Fab>
        </div> */}
            </div>
          </div>
        ) : (
          <Card className="myCard">
            <div className="col-12">
              <Table
                headerClass="headerTable"
                columns={this.state.columns}
                data={this.state.data}
                itemsByPage={10}
                options={{
                  large: false,
                  downloads: {
                    pdf: false,
                    xlsx: false,
                  },
                  pagination: true,
                  search: false,
                }}
              />
              {["1", "7"].includes(this.props.rolId) ? (
                <div className="d-flex justify-content-end pb-3 pr-3 pt-2">
                  <ButtonReactstrap
                    color="primary"
                    onClick={this.toggle}
                  >
                    <span className="icon-plus icon-button-add no-margin" />
                  </ButtonReactstrap>
                </div>
              ) : (
                ""
              )}
            </div>
          </Card>
        )}

        {/* <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>
            {this.props.t("create_new_document")}
          </ModalHeader>
          <ModalBody>
            <AddDocuments
              callback={this.callback}
              onError={this.onError}
              id={this.state.id}
              _user={this.props._user}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.openDeleteModal}
          toggle={this.toggleDeleteModal}
        >
          <ModalHeader
            id={"delete_document"}
            className="header Modal Remove Document"
            toggle={this.toggleDeleteModal}
          >
            <span className="euro-title-form">{this.props.t("delete_document")}</span>
          </ModalHeader>
          <ModalBody>
            <center>
              {this.props.t("are_sure_delete_document", {
                docname: this.state.nameDoc,
              })}
            </center>
          </ModalBody>
          <ModalFooter>
            <ButtonReactstrap
              color="primary"
              className="custom-width-btn"
              onClick={this.removeDocumentModal}
            >
              {this.props.t("yes")}
            </ButtonReactstrap>{" "}
            <ButtonReactstrap
              color="secondary"
              className="custom-width-btn"
              onClick={this.toggleDeleteModal}
            >
              {this.props.t("cancel")}
            </ButtonReactstrap>
          </ModalFooter>
        </Modal> */}

        {createModal({
          isModalOpen: modal,
          titleModal: this.props.t("create_new_document"),
          component: <AddDocuments
            callback={this.callback}
            onError={this.onError}
            id={this.state.id}
            _user={this.props._user}
            onCancel={this.toggle}
          />,
          onCancel: this.toggle,
          width: '500px',
          destroyOnClose: true
        })}

        {createModal({
          isModalOpen: openDeleteModal,
          titleModal: this.props.t("delete_document"),
          component: (
            <>
              <div className="col-12" style={{ textAlign: "center" }}>
                <p>{this.props.t("are_sure_delete_document", { docname: this.state.nameDoc })}</p>
              </div>
            </>
          ),
          buttons: [
            {
              text: this.props.t("cancel"),
              onClick: this.toggleDeleteModal,
              type: "secondary",
            },
            {
              text: this.props.t("yes"),
              onClick: this.removeDocumentModal,
              type: "primary",
            },
          ],
          onCancel: this.toggleDeleteModal
        })}
      </>
    );
  }
}

export default withNamespaces()(withRouter(Tracking));
